import { render } from "./NewGameList.vue?vue&type=template&id=59a2d669&scoped=true"
import script from "./NewGameList.vue?vue&type=script&lang=js"
export * from "./NewGameList.vue?vue&type=script&lang=js"

import "./NewGameList.vue?vue&type=style&index=0&id=59a2d669&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a2d669"]])

export default __exports__